import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        roles: ['ADMIN', 'USER'],
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'rooms',
        path: `${APP_PREFIX_PATH}/classrooms`,
        roles: ['ADMIN'],
        component: React.lazy(() => import('views/app-views/classrooms/index')),
    },
    {
        key: 'teams',
        path: `${APP_PREFIX_PATH}/teams`,
        roles: ['ADMIN'],
        component: React.lazy(() => import('views/app-views/teams/index')),
    },
    {
        key: 'holidays',
        path: `${APP_PREFIX_PATH}/holidays`,
        roles: ['ADMIN'],
        component: React.lazy(() => import('views/app-views/holidays/index')),
    },
    {
        key: 'users',
        path: `${APP_PREFIX_PATH}/users`,
        roles: ['ADMIN'],
        component: React.lazy(() => import('views/app-views/users/index')),
    },
    
]